import React from "react";
import TextButton from "./TextButton";
import { orderStatus } from "../../constants/commonConstants";
import {
  currencyFormatter,
  formatOrderStatus,
  getUptoFourteenDaysLater,
} from "../../utils/formatting";
import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_MM_A } from "../../utils/dateFormating";

const OrdersRow = ({
  order,
  onViewOrder,
  setSelectedFullPreview,
  setOpenModal,
  buttonText,
  tableName,
}) => {
  // Determine the orderStatus color
  const getOrderStatusColor = (status) => {
    if (
      [
        orderStatus.PENDING_PAYMENT,
        orderStatus.IN_REVISION,
        orderStatus.COMPLAINT_RAISED,
      ].includes(status)
    ) {
      return "text-light-red";
    } else if (status === orderStatus.ORDER_IN_PROGRESS) {
      return "text-[#06BCCC]";
    } else if (
      [
        orderStatus.ORDER_DELIVERED,
        orderStatus.CANCELLED,
        orderStatus.RESOLVED,
      ].includes(status)
    ) {
      return "text-blue-shades";
    } else {
      return "text-gray-500"; // Default color if no status matches
    }
  };

  const getOrderStatusText = (status) => {
    // Check if the status exists in the orderStatus object
    if (orderStatus[status]) {
      return formatOrderStatus(orderStatus[status]);
    } else {
      return status || "Unknown Status"; // Return a fallback string if undefined
    }
  };

  // Check if content is truncated
  const isTruncated = (element) => {
    return element.scrollWidth > element.clientWidth;
  };

  const handleMouseEnter = (e) => {
    const element = e.target;
    if (isTruncated(element)) {
      element.setAttribute("title", element.textContent);
    } else {
      element.removeAttribute("title");
    }
  };

  const isButtonDisabled = () => {
    if (tableName === orderStatus.COMPLAINT_RAISED) {
      const completedDate = order?.completedDate;
      if (!completedDate) return true; // Disable if no deadline

      const fourteenDaysLater = getUptoFourteenDaysLater(completedDate);
      const currentDate = new Date();

      return (
        order?.status === orderStatus.RESOLVED || order?.status === orderStatus.COMPLAINT_RAISED ||
        (order?.status === orderStatus.COMPLETED &&
          fourteenDaysLater < currentDate)
      );
    }
  };

  return (
    <tr className="h-[56px] normalContent sm:text-level-5 md:text-level-4 text-gray leading-[19.36px] font-normal font-inter">
      <td className="px-[15px]">{order?.id}</td>
      <td
        className="px-[15px] max-w-[120px] 1366-br:max-w-[230px] 2xl:max-w-[370px] truncate cursor-pointer"
        onClick={() => {
          setSelectedFullPreview(order?.orderRequirements?.subject);
          setOpenModal(true);
        }}
        onMouseEnter={handleMouseEnter} // Add tooltip logic
      >
        {order?.orderRequirements?.subject}
      </td>
      <td className="px-[15px]">$ {order?.price}.00</td>
      <td className={`px-[15px] ${getOrderStatusColor(order?.status)}`}>
        {getOrderStatusText(order?.status)}
      </td>
      <td className="px-[15px]">{formatYYYY_MM_DD(order?.createdAt || '') || ''}</td>
      <td className="px-[15px]">
        {
          tableName === "ALL" ||
          order?.status === orderStatus.ORDER_IN_PROGRESS || 
          order?.status === orderStatus.ORDER_DELIVERED || 
          order?.status === orderStatus.PENDING_WRITER || 
          order?.status === orderStatus.IN_REVISION ||
          order?.status === orderStatus.PENDING_PAYMENT ? 
          formatYYYY_MM_DD_HH_MM_A(order?.orderRequirements?.deadline || '') || '' 
          :formatYYYY_MM_DD(order?.completedDate || '') || ''
        }
      </td>
      <td className="px-[15px]">
        <TextButton
          onClick={() => onViewOrder(order?.id, order?.threadId, order?._id)}
          text={
            (order?.status === orderStatus.RESOLVED && tableName === orderStatus.COMPLAINT_RAISED)? 
            formatOrderStatus(orderStatus.RESOLVED) : 
            (order?.status === orderStatus.COMPLAINT_RAISED && tableName === orderStatus.COMPLAINT_RAISED) ? 
            "Already Raised" : 
            buttonText || "View Order"
          }
          width="127px"
          height="35px"
          disabled={isButtonDisabled()}
        />
      </td>
    </tr>
  );
};

export default OrdersRow;
